import { render, staticRenderFns } from "./UmbInvestmentAccountPage.vue?vue&type=template&id=dcf91a36&scoped=true"
import script from "./UmbInvestmentAccountPage.vue?vue&type=script&lang=ts"
export * from "./UmbInvestmentAccountPage.vue?vue&type=script&lang=ts"
import style0 from "./UmbInvestmentAccountPage.vue?vue&type=style&index=0&id=dcf91a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf91a36",
  null
  
)

export default component.exports